export default __webpack_public_path__ + "static/media/error.2bc45936.svg";